import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  topBrandItems: {
    required,
  },
};

export default validations;
